import ImpfFormStart from '../../../components/impfschaeden/assistent/VaxForm_00_start.js';
import PropTypes from 'prop-types';
import HeaderImage from 'components/layout/Header/components/HeaderImage.js';

const OverView = (props) => {
	return (
		<div>
			<HeaderImage />
			<ImpfFormStart masterData={props.masterData} />
		</div>
	);
};

OverView.propTypes = {
	masterData: PropTypes.object,
};

export default OverView;
